import styled from '../../theme/styled-with-theme';
import { Box } from '../Box';
import { mediaQueries } from '../../styles/media-queries';

export const PressItem = styled(Box)`
  width: 33%;
  text-align: center;

  ${mediaQueries.desktop} {
    width: 25%;
  }

  img {
    max-width: 100%;
    ${mediaQueries.desktop} {
      max-width: 210px;
    }
  }
`;
